import React, { useState, useEffect } from "react";
import TextInput from "../library/TextInput";
import PaginatedTable from "../library/Pagination";
import API_BASE_URL from "../../config/api";

const AcademicData = ({ userId }) => {
  const [rows, setRows] = useState([]);
  const [notification, setNotification] = useState(null);

  const fetchData = () => {
    fetch(`${API_BASE_URL}/api/AcademicData/employee/${userId}`)
      .then((res) => res.json())
      .then((data) =>
        setRows(data.map((r) => ({ ...r, isEditing: false })))
      )
      .catch(console.error);
  };

  useEffect(fetchData, [userId]);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    if (field === "year") {
      const currentYear = new Date().getFullYear();
      const numericYear = Number(value);

      if (numericYear > currentYear) {
        setNotification({ type: "error", message: `Year cannot be greater than ${currentYear}` });
        return;
      }
    }
    updated[index][field] = value;
    setRows(updated);
  };

  const handleEditToggle = async (index) => {
    const updated = [...rows];
    const row = updated[index];

    const payload = {
      Id: row.id || 0,
      Degree: row.degree || "",
      Institution: row.institution || "",
      Year: row.year || "",
      Specialization: row.specialization || "",
      EmployeeId: userId,
      Employee: { Id: userId }
    };

    if (row.isEditing) {

      if (!payload.Degree || !payload.Institution || !payload.Year || !payload.Specialization) {
        setNotification({ type: "error", message: `Please fill in all fields before saving.` });
        return;
      }

      const method = row.id ? "PUT" : "POST";
      const url = row.id
        ? `${API_BASE_URL}/api/AcademicData/PutPostAcademicData/${row.id}`
        : `${API_BASE_URL}/api/AcademicData/PostAcademicData`;

      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("API Error:", response.status, errorText);
      } else {
        fetchData(); // Refresh rows from DB
      }
    }

    updated[index].isEditing = !updated[index].isEditing;
    setRows(updated);
  };


  const handleDelete = async (index) => {
    const row = rows[index];
    if (row.id)
      await fetch(`${API_BASE_URL}/api/AcademicData/${row.id}`, {
        method: "DELETE",
      });
    setRows(rows.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        degree: "",
        institution: "",
        year: "",
        specialization: "",
        isEditing: true,
      },
    ]);
  };

  const closeNotification = () => setNotification(null);

  return (
    <div className="p-4">
      <h2 className="text-[#111518] text-[22px] font-bold leading-tight tracking-[-0.015em] pb-3">
        Academic Data
      </h2>

      {notification && (
        <div
          className={`mb-4 p-4 rounded ${notification.type === "error"
            ? "bg-red-100 text-red-700"
            : "bg-green-100 text-green-700"
            }`}
        >
          <div className="flex justify-between items-center">
            <span>{notification.message}</span>
            <button onClick={closeNotification} className="font-bold text-xl leading-none">
              ×
            </button>
          </div>
        </div>
      )}

      <div className="px-4 py-3">
        <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
          <PaginatedTable
            columns={[
              "Degree",
              "Institution",
              "Year",
              "Specialization",
              "Action",
            ]}
            data={rows}
            pageSize={10}
            showPagination={false}
            renderRow={(row, index) => (
              <tr key={row.id || index} className="border-t border-t-[#dde1e3]">
                <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                  <TextInput
                    value={row.degree}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) => handleChange(index, "degree", e.target.value)}
                  />
                </td>
                <td className="h-[72px] px-4 py-2 text-[#121516] text-sm font-normal leading-normal">
                  <TextInput
                    value={row.institution}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) =>
                      handleChange(index, "institution", e.target.value)
                    }
                  />
                </td>
                <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-normal leading-normal">
                  <TextInput
                    type="number"
                    value={row.year}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) => handleChange(index, "year", e.target.value)}
                  />
                </td>

                <td className="h-[72px] px-4 py-2 text-[#6a7881] text-sm font-bold leading-normal tracking-[0.015em]">
                  <TextInput
                    value={row.specialization}
                    className={row.isEditing ? "input-editing" : "input-readonly"}
                    disabled={!row.isEditing}
                    onChange={(e) =>
                      handleChange(index, "specialization", e.target.value)
                    }
                  />
                </td>

                <td className="h-[72px] px-4 py-2 text-sm font-normal leading-normal">
                  <div className="flex gap-2">
                    <button
                      className="text-blue-600"
                      onClick={() => handleEditToggle(index)}
                    >
                      {row.isEditing ? "Save" : "Edit"}
                    </button>
                    <button
                      className="text-red-600"
                      onClick={() => handleDelete(index)}
                    >
                      Delete
                    </button>
                  </div>
                </td>

              </tr>
            )}
          />

        </div>
      </div>

      <div className="col-span-5 flex justify-end">
        <button
          // className="bg-gray-200 px-4 py-2 rounded mt-4"
          className="btn-black"
          onClick={handleAddRow}
        >
          + Add Row
        </button>
      </div>


    </div>
  );
};

export default AcademicData;
